import {App, ConfigProvider, Spin, theme} from 'antd';
import {useMemo} from "react";
import {Spinner, themeDark, themeLite} from "@/theme";

Spin.setDefaultIndicator(<Spinner />)

export const AntdConfigProvider = ({children}) => {

    const {defaultAlgorithm, darkAlgorithm} = theme;
    const themeType = 'light'
    const themSetting = useMemo(()=>{
        switch (themeType) {
            case 'light':
                return {
                    algorithm: defaultAlgorithm,
                    ...themeLite,
                }
            case 'dark':
                return {
                    algorithm: darkAlgorithm,
                    ...themeDark,
                }
            default:
                return {
                    algorithm: defaultAlgorithm,
                    ...themeLite,
                }

        }
    }, [themeType])

    return (
        <>
            <ConfigProvider
                theme={{
                    ...themSetting,
                    cssVar: { key: themeType }
                }}
            >
                <App className={`${themeType}_mode`}>
                    {children}
                </App>
            </ConfigProvider>
        </>
    );
}